// extracted by css-extract-rspack-plugin
export default {"Divider":"ResourcesSection-module__Divider__mp0Fd"};